import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import "./survey.css";
import {
    Box,
    Heading,
    Container,
    Stack,
} from '@chakra-ui/react';

import ProgressMutation from '../graphql/mutations/updateProgress'
import CreateProgressMutation from '../graphql/mutations/createProgress'
import { useMutation, useQuery } from '@apollo/client'
import * as Survey from "survey-react";
import progressbyId from '../graphql/queries/progressbyId'

import dayjs from 'dayjs';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import sendSurveyByContentId from '../graphql/queries/sendSurveyByContentId';
import createSurvey from '../graphql/mutations/createSurvey';
import AuthContext from '../contexts/AuthContext';
import renderHTML from 'react-render-html';
import draftToHtml from 'draftjs-to-html';


require('dayjs/locale/th')
require('dayjs/locale/en')

var localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(localizedFormat)

const SendSurveyPage = () => {
    const { contentId } = useParams()
    const location = useLocation()
    const { user } = useContext(AuthContext)
    const userId = user?._id
    const [setUpdateProgress] = useMutation(ProgressMutation)
    const [setCreateProgress] = useMutation(CreateProgressMutation)

    const [setSurveyMutation] = useMutation(createSurvey)
    const [isCompleted, setisCompleted] = useState(false)
    const [answers, setAnswers] = useState('')
    const [surveyRender, setSurveyRender] = useState(null)


    const { data: Surveys } = useQuery(sendSurveyByContentId, {
        variables: {
            _id: contentId,
        },
    })

    const { data: userprogress } = useQuery(progressbyId, {
        variables: {
            content: contentId,
            student: userId
        },
        skip: !userId,
    })

    const progressId = userprogress?.progress?._id
    const canAccessSurvey = Boolean(userId || Surveys?.content?.public === true)

    const onCompleteComponent = useCallback(async (survey) => {
        setisCompleted(true)
        try {
            const { data: surveyResponse } = await setSurveyMutation({
                variables: {
                    content: contentId,
                    student: userId,
                    surveyAnswers: survey?.data,
                    status: 'submit',
                },
            })
            if (surveyResponse && userId) {
                const progressVariables = {
                    content: contentId,
                    student: userId,
                    progress: 100,
                    path: window.location.href,
                }
                const { data: ProgressData } = progressId
                    ? await setUpdateProgress({
                        variables: {
                            _id: progressId,
                            progress: 100
                        }
                    })
                    : await setCreateProgress({
                        variables: progressVariables
                    })
                if (ProgressData) {
                    console.log(ProgressData)
                }
            }
            var results = JSON.stringify(survey.data);
            survey.showPreviewBeforeComplete = results
            setAnswers(survey.data)
        } catch (error) {
            console.log(error)
        }
    }, [contentId, progressId, setCreateProgress, setSurveyMutation, setUpdateProgress, userId])

    const handleConvertHTML = (text) => {
        if (text) {
            return renderHTML(draftToHtml(text))
        }
        return ''
    }

    useEffect(() => {
        if (!isCompleted && surveyRender === null && Surveys && canAccessSurvey) {
            var survey = <Survey.Survey
                json={{ questions: Surveys?.content?.surveyconfig?.surveyQuestions?.questions }}
                showCompletedPage={true}
                onComplete={onCompleteComponent}
                showPreviewBeforeComplete='noPreview'
                // isEditingSurveyElement={false}
                completedHtml={`<h1>ขอบคุณที่ตอบแบบสอบถาม</h1>`}
            // mode={'display'}
            />
            setSurveyRender(survey)
        }
    }, [answers, canAccessSurvey, isCompleted, onCompleteComponent, surveyRender, Surveys])

    if (Surveys?.content && !canAccessSurvey) {
        return <Redirect to={{ pathname: '/login', state: { from: location } }} />
    }

    return (
        <Fragment>
            <Box w="100%" px={"20"} minHeight={'90vh'}>
                <Container maxW={'8xl'} mt={2} py={10} as={Stack} spacing={12}>
                    <Box>
                        <Heading size="xl" mt={2}>
                            {Surveys?.content?.name}
                        </Heading>
                        {handleConvertHTML(Surveys?.content?.surveyconfig?.description)}
                        {surveyRender}
                    </Box>
                </Container>
            </Box>
        </Fragment>
    );
};

export default SendSurveyPage;
